module.exports = __webpack_public_path__ + "img/antes_despues_98.fdd6e7e9.png";